import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {HttpErrorService} from '../services/http-error.service';
import {ToastService} from '@ratespecial/core';

/**
 * If any ajax call results in an error, we handle here to avoid duplicate code in the various components
 * and services that make requests.  422 Errors are not caught to allow Form Validation Errors to be handled
 * by the component directly
 *
 * Note: Most RS functionality is standardized to our Api Error object.  There are some edge cases with
 * laravel and third party libs that may not be trapped and converted to Api Errors by the Laravel global
 * error handler and thus come back in another form.  I'm fixing those as they surface  - Joe
 */
export const serverErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notificationService = inject(ToastService);
  const httpErrorService = inject(HttpErrorService);

  return next(req)
    .pipe(
      tap({
        error: err => {
          // Allow 422 pass through to the component's form validation handler because use cases vary for forms
          // and modal windows that need a different error presentation than the typical alert logic.
          // Allow 401 to be handled by auth interceptor
          if (err instanceof HttpErrorResponse && err.status !== 422 && err.status !== 401) {
            httpErrorService.handleError(err);
          } else if (err.error instanceof Error) {
            notificationService.error('A Network Error Occurred');
          }
        }
      })
    );
};
